/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useState } from 'react'
import { Disclosure, Menu, Popover, Transition, Dialog } from '@headlessui/react'
import {
  BookmarkAltIcon,
  BriefcaseIcon,
  ChartBarIcon,
  CheckCircleIcon,
  CursorClickIcon,
  DesktopComputerIcon,
  GlobeAltIcon,
  InformationCircleIcon,
  MenuIcon,
  NewspaperIcon,
  OfficeBuildingIcon,
  PhoneIcon,
  PlayIcon,
  ShieldCheckIcon,
  UserGroupIcon,
  UserCircleIcon,
  ViewGridIcon,
  XIcon,
} from '@heroicons/react/outline'
import { ChevronDownIcon } from '@heroicons/react/solid'
import { Link, useHistory } from "react-router-dom";

import { useUser } from '../providers/UserProvider'
import { useNotification } from '../providers/NotificationProvider'
import { useTheme } from '../providers/ThemeProvider'

import Cta from "./Cta"
import ProfileSettings from "./ProfileSettings"

const navigation = {
  primary: [
    //{ name: 'Discover', href: '/', current: false },
    { id: "top_nav_marketplace", name: 'Marketplace', href: '/marketplace', current: false },
    { id: "top_nav_partners", name: 'Partners', href: '/pilotprogram', current: false },
    { id: "top_nav_resources", name: 'Resources', href: '/blog', current: false },
  ],
  secondary: [
    { id: "secondary_nav_how_it_works", name: 'How it Works', href: '/how-it-works', current: true },
    { id: "secondary_nav_team", name: 'Team', href: '/team', current: false },
    { id: "secondary_nav_careers", name: 'Careers', href: '/jobs', current: false },
    { id: "secondary_nav_partners", name: 'Partners', href: '/pilotprogram', current: false },
    { id: "secondary_nav_privacy_policy", name: 'Privacy Policy', href: '/privacy-policy', current: false },
    { id: "secondary_nav_tos", name: 'Terms of Service', href: '/terms-of-service', current: false },
  ],
  profile: [
  ]
}

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const ProfileDropdown = (props) => {
  const logout = props.logout;

  const [ user, userDispatch ] = useUser();

  return (
                <Menu as="div" className="ml-3 relative font-primary text-black dark:text-white">
                  <div>
                    <Menu.Button className="flex text-sm rounded-full">
                      <span className="sr-only">Open user menu</span>
                      <UserCircleIcon className="h-8 w-8" />
                    </Menu.Button>
                  </div>
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="origin-top-right absolute z-55 right-0 mt-2 w-96 space-y-8 rounded-md shadow-lg py-10 px-12 text-black bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <Menu.Item as="div">
                        <div className="flex flex-row justify-right items-center">
                          <UserCircleIcon className="inline w-12 h-12" /> 
                          <div className="ml-4">
                            <div>Hi, { user.profile.name }</div>
                            <div>{user.profile.email}</div>
                          </div>
                        </div>
                      </Menu.Item>

                      <div className="w-full border-t border-gray-300" />

                      <Menu.Item as="div">
                        <a onClick={() => userDispatch({ type: 'profile/open' })} className="cursor-pointer font-medium text-convoy-light-blue text-subtitle-mobile md:text-subtitle w-80 px-4 py-2 rounded-md hover:bg-grey-filterHover border-b-2 border-transparent ">Profile Settings</a>
                      </Menu.Item>

                      { navigation.profile.map((item) => (
                        <Menu.Item as="div">
                          <Link 
                            to={ item.href }
                            className="cursor-point font-medium text-convoy-light-blue w-80 py-2 px-4 text-subtitle-mobile md:text-subtitle rounded-md hover:bg-grey-filterHover"
                          >
                            {item.name}
                          </Link>
                        </Menu.Item>
                      )) }

                      <Menu.Item as="div">
                        <a id="logout_btn" onClick={() => logout()} className="cursor-pointer font-medium text-convoy-light-blue w-80 py-2 px-4 text-subtitle-mobile md:text-subtitle rounded-md hover:bg-grey-filterHover">Sign Out</a>
                      </Menu.Item>

                    </Menu.Items>
                  </Transition>
                </Menu>

  );
}

function MainHeader(props) {
  const history = useHistory();

  var showLogin = props.showLogin || false;
  var showRegister = props.showRegister || false;
  const [open, setOpen] = useState(false)
  const [user, userDispatch] = useUser();
  const [theme, themeDispatch] = useTheme();
  const [notification, notificationDispatch] = useNotification();

  const logout = () => {
    // Close Request Discount Notification
    notificationDispatch({ type: "notification/hide" });
    localStorage.removeItem('AUTH_TOKEN');
    localStorage.removeItem('preferences');
    userDispatch({
      type: "logout"
    });
    history.replace('/login');
  };

  const productRequest = () => {
    userDispatch({ type: "productRequest/showModal", payload: true });
  };

  return (
    <Popover className={classNames("relative", (theme.headerDark ? 'dark' : ''))}>
      <div className="absolute z-30 pointer-events-none" aria-hidden="true" />
      <div className="relative">
        <div className="flex items-center py-5 md:justify-start md:space-x-10">
          <div className="">
            <a href="/" className="flex">
              <span className="sr-only">Workflow</span>
              { theme.logo &&
                <div className="flex flex-row space-x-6">
                  <div className="pr-6 border-convoy-blue dark:border-white border-r-2">
                    <img
                      className="w-auto h-logo-mobile lg:h-logo dark:brightness-0 dark:invert"
                      src={ !theme.dark ? "/images/logo.png" : "/images/logo_dark.png"}
                      alt="The Convoy Logo"
                    />
                  </div>
                  <div className="">
                    <img
                      className="w-auto h-logo-mobile lg:h-logo"
                      src={theme.logo}
                      alt={theme.logoAlt}
                    />
                  </div>
                </div>
              }
              { !theme.logo &&
                <img
                  className="w-auto h-logo-mobile lg:h-logo dark:brightness-0 dark:invert"
                  src="/images/logo.png"
                  alt="The Convoy Logo"
                />
              }
            </a>
          </div>

          <div className="flex-grow"></div>

          <nav>
            <div className="absolute inset-y-0 right-0 flex items-center xl:hidden">
              <button 
                className="cursor-pointer inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                onClick={() => setOpen(true)}
              >
                <span className="sr-only">Open main menu</span>
                <MenuIcon className="block h-6 w-6" aria-hidden="true" />
              </button>
            </div>

            <div className="hidden xl:block xl:ml-6">
              <div className="flex items-center space-x-16">
                {navigation.primary.map((item) => (
                  <a
                    id={item.id}
                    key={item.name}
                    href={item.href}
                    className={classNames(
                      item.current ? 'border-blue-500' : 'font-medium text-black dark:text-white hover:border-blue-500',
                      "font-primary cursor-pointer text-body-1-md border-b-2 border-transparent "
                    )}
                    aria-current={item.current ? 'page' : undefined}
                  >
                    {item.name}
                  </a>
                ))}

                <button
                  id="product_request"
                  key="product_request"
                  className={classNames(
                    'font-medium text-black dark:text-white hover:border-blue-500',
                    "font-primary cursor-pointer text-body-1-md border-b-2 border-transparent relative "
                  )}
                  onClick={() => productRequest()}
                >
                  Request Discount <span className="absolute ml-3 py-1 px-2 rounded-3 text-body-2 font-bold bg-blue-banner text-blue-bannerTitle font-primary">
                    New
                  </span>
                </button>
                {/* Profile dropdown */}
                { user.loggedIn 
                  && <ProfileDropdown logout={logout} />
                }
                { !user.loggedIn &&
                  <>
                  <a
                    id="login_btn"
                    key="login"
                    href="/login"
                    className={classNames(
                      'font-medium text-black dark:text-white hover:border-blue-500',
                      "font-primary cursor-pointer text-body-1-md border-b-2 border-transparent "
                    )}
                  >
                    Login
                  </a>  

                  <Cta id="join_btn" style="small-style-2" label="Sign Up" href="/register" />
                  </>
                }
              </div>
            </div>
          </nav>

          <ProfileSettings />

          <Transition.Root show={open} as={Fragment}>
            <Dialog as="div" className="z-55 fixed inset-0 overflow-hidden" onClose={setOpen}>
              <div className="absolute inset-0 overflow-hidden">
                <Transition.Child
                  as={Fragment}
                  enter="ease-in-out duration-500"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in-out duration-500"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <Dialog.Overlay className="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity z-55" />
                </Transition.Child>
      
                <div className="fixed z-60 inset-y-0 right-0 pl-10 max-w-full flex">
                  <Transition.Child
                    as={Fragment}
                    enter="transform transition ease-in-out duration-500 sm:duration-700"
                    enterFrom="translate-x-full"
                    enterTo="translate-x-0"
                    leave="transform transition ease-in-out duration-500 sm:duration-700"
                    leaveFrom="translate-x-0"
                    leaveTo="translate-x-full"
                  >
                    <div className="w-screen max-w-md">
                      <div className="h-full flex flex-col py-6 bg-white shadow-xl overflow-y-scroll">
                        <div className="px-4 sm:px-6">
                          <div className="flex items-start justify-between">
                            <Dialog.Title className="text-lg font-medium text-gray-900"></Dialog.Title>
                            <div className="ml-3 h-7 flex items-center">
                              <button
                                type="button"
                                className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                onClick={() => setOpen(false)}
                              >
                                <span className="sr-only">Close panel</span>
                                <XIcon className="h-6 w-6" aria-hidden="true" />
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="mt-6 relative flex-1 font-primary">
                          {/* First Section */}
                          <div className="flex flex-col px-8 space-y-4 mb-4">
                            {navigation.primary.map((item) => (
                              <a
                                id={item.id}
                                key={item.name}
                                href={item.href}
                                className={classNames(
                                  "text-black text-subtitle-mobile md:text-subtitle border-b-2 border-transparent "
                                )}
                                aria-current={item.current ? 'page' : undefined}
                              >
                                {item.name}
                              </a>
                            ))}

                            <button
                              id="product_request"
                              key="product_request"
                              className={classNames(
                                "text-left text-black text-subtitle-mobile md:text-subtitle border-b-2 border-transparent relative "
                              )}
                              onClick={() => productRequest()}
                            >
                              Request Discount <span className="absolute ml-3 py-1 px-2 rounded-3 text-body-2 font-bold bg-blue-banner text-blue-bannerTitle font-primary">
                                New
                              </span>
                            </button>
                          </div>
                          <div className="w-full border-t border-gray-300" />
                          {/* /End First Section */}

                          {/* Second Section */}
                          <div className="flex flex-col px-8 space-y-4 my-4">
                            { user.loggedIn &&
                            <>
                            <div className="justify-center"><UserCircleIcon className="inline w-8 h-8" /> Hi, { user.profile.name }</div>

                            <a 
                              onClick={() => {
                                setOpen(false);
                                userDispatch({ type: 'profile/open' });
                              }}
                              className="cursor-pointer text-convoy-light-blue text-subtitle-mobile md:text-subtitle border-b-2 border-transparent ">
                                Profile Settings
                              </a>

                            { navigation.profile.map((item) => (
                              <Link to={ item.href } className="cursor-pointer text-convoy-light-blue text-subtitle-mobile md:text-subtitle border-b-2 border-transparent ">{item.name}</Link>
                            )) }

                            <a id="logout_btn" onClick={logout} className="cursor-pointer text-convoy-light-blue text-subtitle-mobile md:text-subtitle border-b-2 border-transparent ">Sign Out</a>
                            </>
                            }

                            { !user.loggedIn &&
                              <>
                              <a href="/register" className="cursor-pointer w-40 inline-flex items-center justify-center px-8 py-2 border border-transparent font-cta-label text-cta-label-mobile md:text-cta-label font-medium rounded-full text-white bg-blue-500 hover:bg-blue-400 ">Sign Up</a>
                              <a href="/login" className="cursor-pointer text-convoy-light-blue text-subtitle-mobile md:text-subtitle border-b-2 border-transparent ">Login</a>
                              </>
                            }
                          </div>
                          <div className="w-full border-t border-gray-300" />
                          {/* /End Second Section */}

                          {/* Third Section */}
                          <div className="flex flex-col px-8 space-y-4 my-4">
                            {navigation.secondary.map((item) => (
                              <a
                                id={item.id}
                                key={item.name}
                                href={item.href}
                                className={classNames(
                                  "cursor-pointer text-grey-light text-sm md:text-sm border-b-2 border-transparent "
                                )}
                                aria-current={item.current ? 'page' : undefined}
                              >
                                {item.name}
                              </a>
                            ))}
                          </div>
                          {/* /End Third Section */}
                        </div>
                      </div>
                    </div>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition.Root>
        </div>
      </div>

    </Popover>
  )
}

export default MainHeader;
